// App Android (TWA chat.floow.app). Ele abre o painel com ?origem=android e
// com referrer android-app://chat.floow.app. Dentro do app nao se vende nada:
// a regra de pagamentos da Google Play exige o sistema de cobranca dela para
// assinatura e creditos comprados no app. Cadastro, assinatura e compra de
// creditos ficam so no site (no navegador continua tudo igual).
// A marca fica no sessionStorage: o TWA divide os dados com o Chrome do
// celular, e no localStorage ela vazaria para quem abre o site no navegador.
const CHAVE = "floow:appAndroid";

export const ehAppAndroid = () => {
  try {
    if (sessionStorage.getItem(CHAVE) === "1") return true;
    const marcado =
      /[?&]origem=android(&|$)/.test(window.location.search) ||
      String(document.referrer || "").indexOf("android-app://chat.floow.app") === 0;
    if (marcado) sessionStorage.setItem(CHAVE, "1");
    return marcado;
  } catch (e) {
    return false;
  }
};
